


















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ChengduSettingDialog extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private dialogVisible: boolean | undefined;
  @Prop()
  private noModal: any;
  private dialogVisibleChange() {
    this.$emit("update:dialogVisible", this.dialogVisible);
  }
  private ziduanChange() {
    this.$emit("update:ziduan", this.ziduan);
  }
  /**
   * @description 关闭前回调
   */
  private handleClose() {
    this.$emit("update:dialogVisible", false);
  }
}
